<template>
  <section class="main-page">
    <section class="page-section mb-3">
      <div class="container-fluid">
        <div class="grid justify-content-between">
          <div class="col-12 md:col-6 lg:col-5">
            <div class="">
              <div class="flex align-items-center">
                <div>
                  <Avatar size="large" class="primary" icon="pi pi-home" />
                </div>
                <div class="ml-2 mr-3">
                  <div class="text-2xl text-primary font-bold">Dashboard</div>
                  <div class="text-sm text-500">
                    Overview count of application data entries
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <hr />
    <api-data-source
      api-path="components_data/getdashboardcount"
      v-slot="record"
    >
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="card py-2 nice-shadow-6">
            <div class="text-lg text-primary">Applications Overview</div>
          </div>
        </div>
      </section>
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="grid">
            <div class="col-12 md:col-4 comp-grid">
              <router-link :to="`applicants`">
                <div class="card bg-green-100 nice-shadow-6">
                  <div class="flex justify-content-between mb-3">
                    <div>
                      <div class="font-medium mb-3">Total Applications</div>
                      <div class="font-medium text-xl" v-if="!record.loading">
                        {{ record.response.getcount_totalapplications }}
                      </div>
                      <ProgressSpinner
                        v-else
                        style="width: 20px; height: 20px"
                      />
                    </div>
                    <div style="width: auto">
                      <Avatar
                        icon="pi pi-th-large"
                        size="large"
                        class="text-white bg-green-600"
                      />
                    </div>
                  </div>
                  <span class="text-500 text-sm"
                    >Total number of applications created</span
                  >
                </div>
              </router-link>
            </div>
            <div class="col-12 md:col-4 comp-grid">
              <router-link
                :to="`/applicants/unprocessedapplications/Pending?label=Unprocessed Applications&tag=Applicants`"
              >
                <div class="card bg-yellow-100 nice-shadow-6">
                  <div class="flex justify-content-between mb-3">
                    <div>
                      <div class="font-medium mb-3">
                        Unprocessed Applications
                      </div>
                      <div class="font-medium text-xl" v-if="!record.loading">
                        {{
                          record.response.getcount_totalunprocessedapplications
                        }}
                      </div>
                      <ProgressSpinner
                        v-else
                        style="width: 20px; height: 20px"
                      />
                    </div>
                    <div style="width: auto">
                      <Avatar
                        icon="pi pi-th-large"
                        size="large"
                        class="text-yellow-100 bg-yellow-700"
                      />
                    </div>
                  </div>
                  <span class="text-500 text-sm"
                    >Total number of applications awaiting processing</span
                  >
                </div>
              </router-link>
            </div>
            <div class="col-12 md:col-4 comp-grid">
              <router-link
                :to="`/applicants/rejectedapplications/Rejected?label=Rejected Applications&tag=Applicants`"
              >
                <div class="card bg-pink-100 nice-shadow-6">
                  <div class="flex justify-content-between mb-3">
                    <div>
                      <div class="font-medium mb-3">Rejected Applications</div>
                      <div class="font-medium text-xl" v-if="!record.loading">
                        {{ record.response.getcount_totalrejectedapplications }}
                      </div>
                      <ProgressSpinner
                        v-else
                        style="width: 20px; height: 20px"
                      />
                    </div>
                    <div style="width: auto">
                      <Avatar
                        icon="pi pi-th-large"
                        size="large"
                        class="text-pink-100 bg-pink-700"
                      />
                    </div>
                  </div>
                  <span class="text-500 text-sm"
                    >Total number of applications rejected by institution</span
                  >
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </section>
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="card py-2 nice-shadow-6">
            <div class="text-lg text-primary">Admissions Overview</div>
          </div>
        </div>
      </section>
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="grid">
            <div class="col-12 md:col-4 comp-grid">
              <router-link :to="`/applicants/admissions`">
                <div class="card bg-purple-100 nice-shadow-6">
                  <div class="flex justify-content-between mb-3">
                    <div>
                      <div class="font-medium mb-3">Admissions Offered</div>
                      <div class="font-medium text-xl" v-if="!record.loading">
                        {{
                          record.response.getcount_totalinstitutionadmissions
                        }}
                      </div>
                      <ProgressSpinner
                        v-else
                        style="width: 20px; height: 20px"
                      />
                    </div>
                    <div style="width: auto">
                      <Avatar
                        icon="pi pi-th-large"
                        size="large"
                        class="text-white bg-purple-600"
                      />
                    </div>
                  </div>
                  <span class="text-500 text-sm"
                    >Total number admissions offered</span
                  >
                </div>
              </router-link>
            </div>
            <div class="col-12 md:col-4 comp-grid">
              <router-link :to="`/applicants/confirmed_admissions`">
                <div class="card bg-green-100 nice-shadow-6">
                  <div class="flex justify-content-between mb-3">
                    <div>
                      <div class="font-medium mb-3">Confirmed Admissions</div>
                      <div class="font-medium text-xl" v-if="!record.loading">
                        {{ record.response.getcount_totalconfirmedadmissions }}
                      </div>
                      <ProgressSpinner
                        v-else
                        style="width: 20px; height: 20px"
                      />
                    </div>
                    <div style="width: auto">
                      <Avatar
                        icon="pi pi-th-large"
                        size="large"
                        class="text-white bg-green-600"
                      />
                    </div>
                  </div>
                  <span class="text-500 text-sm"
                    >Total confirmed admissions by applicants</span
                  >
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </section>
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="card py-2 nice-shadow-6">
            <div class="text-lg text-primary">Institution Information</div>
          </div>
        </div>
      </section>
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="grid">
            <div class="col-12 md:col-4 comp-grid">
              <router-link :to="`institution_campuses`">
                <div class="card bg-blue-100 nice-shadow-6">
                  <div class="flex justify-content-between mb-3">
                    <div>
                      <div class="font-medium mb-3">Campuses</div>
                      <div class="font-medium text-xl" v-if="!record.loading">
                        {{ record.response.getcount_campuses }}
                      </div>
                      <ProgressSpinner
                        v-else
                        style="width: 20px; height: 20px"
                      />
                    </div>
                    <div style="width: auto">
                      <Avatar
                        icon="pi pi-th-large"
                        size="large"
                        class="text-white bg-primary"
                      />
                    </div>
                  </div>
                  <span class="text-500 text-sm"
                    >Total Institution Campuses</span
                  >
                </div>
              </router-link>
            </div>
            <div class="col-12 md:col-4 comp-grid">
              <router-link :to="`institution_schools`">
                <div class="card bg-blue-100 nice-shadow-6">
                  <div class="flex justify-content-between mb-3">
                    <div>
                      <div class="font-medium mb-3">Departments</div>
                      <div class="font-medium text-xl" v-if="!record.loading">
                        {{ record.response.getcount_schoolsdepartments }}
                      </div>
                      <ProgressSpinner
                        v-else
                        style="width: 20px; height: 20px"
                      />
                    </div>
                    <div style="width: auto">
                      <Avatar
                        icon="pi pi-th-large"
                        size="large"
                        class="text-white bg-primary"
                      />
                    </div>
                  </div>
                  <span class="text-500 text-sm"
                    >Total Institution Departments</span
                  >
                </div>
              </router-link>
            </div>
            <div class="col-12 md:col-4 comp-grid">
              <router-link :to="`institution_programmes`">
                <div class="card bg-blue-100 nice-shadow-6">
                  <div class="flex justify-content-between mb-3">
                    <div>
                      <div class="font-medium mb-3">Programmes</div>
                      <div class="font-medium text-xl" v-if="!record.loading">
                        {{ record.response.getcount_programmes }}
                      </div>
                      <ProgressSpinner
                        v-else
                        style="width: 20px; height: 20px"
                      />
                    </div>
                    <div style="width: auto">
                      <Avatar
                        icon="pi pi-th-large"
                        size="large"
                        class="text-white bg-primary"
                      />
                    </div>
                  </div>
                  <span class="text-500 text-sm"
                    >Total Institution Programmes</span
                  >
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </section>
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="card py-2 nice-shadow-6">
            <div class="text-lg text-primary">Application Payment Overview</div>
          </div>
        </div>
      </section>
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="grid">
            <div class="col-12 md:col-4 comp-grid">
              <router-link :to="`payments`">
                <div class="card nice-shadow-6">
                  <div class="flex justify-content-between mb-3">
                    <div>
                      <div class="font-medium mb-3">Total Payments</div>
                      <div class="font-medium text-xl" v-if="!record.loading">
                        {{ record.response.getcount_payments }}
                      </div>
                      <ProgressSpinner
                        v-else
                        style="width: 20px; height: 20px"
                      />
                    </div>
                    <div style="width: auto">
                      <Avatar icon="pi pi-th-large" size="large" class="" />
                    </div>
                  </div>
                  <span class="text-500 text-sm"
                    >Click to view all transactions</span
                  >
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </section>
    </api-data-source>
  </section>
</template>
<script>
import { PageMixin } from "../../mixins/page.js";
export default {
  name: "homePage",
  components: {},
  mixins: [PageMixin],
  props: {},
  data: function () {
    return {
      ready: false,
    };
  },
  computed: {
    pageTitle: {
      get: function () {
        return "Home";
      },
    },
  },
  methods: {},
  watch: {},
  async mounted() {
    this.ready = true;
  },
  async created() {},
};
</script>
<style scoped></style>
